import RootStore from '../store/root-store.ts';
import {createContext} from 'react';

export const RootStoreContext = createContext<RootStore | null>(null);